<template>
  <div>
    <v-container fluid pa-0>
        <div class="content pa-lg-16 pa-8">
            <div class="display-1 mb-6 font-weight-bold">
                FAQ
            </div>
            <v-row no-gutters wrap align="start">
                <!-- <v-col sm="12" md="6" lg="6"> -->
                    <v-card class="faq mb-8" width="630" height="200">
                        <div class="pa-2">
                            <v-card-title class="faqTitle">
                                Apa yang dimaksud dengan QRIS?
                            </v-card-title>
                            <v-card-text>
                                QRIS memiliki kepanjangan Quick Response Code Indonesian Standard. QRIS ini adalah standarisasi pembayaran menggunakan metode QR Code dari Bank Indonesia agar proses transaksi dengan QR Code yang kalian lakukan lebih mudah, cepat, dan terjaga keamanannya
                            </v-card-text>
                        </div>
                    </v-card>
                    <v-card class="faq  mb-8 ml-8" width="630" height="200">
                        <div class="pa-2">
                            <v-card-title class="faqTitle">
                                Apa yang membedakan QRIS dengan QR Code pembayaran<br /> yang telah digunakan selama ini?
                            </v-card-title>
                            <v-card-text>
                                Dengan adanya QRIS, maka sekarang seluruh transaksi pembayaran yang menggunakan QR Code hanya memerlukan satu QRIS aja.. karena kode QRIS itu sudah terintegrasi dengan seluruh aplikasi yang menyediakan dan/atau menerima pembayaran dengan QR code
                            </v-card-text>
                        </div>
                    </v-card>
                    <v-card class="faq mb-5" width="630" height="200">
                        <div class="pa-2">
                            <v-card-title class="faqTitle">
                                Darimana sajakah sumber dana yang digunakan pada transaksi QRIS?
                            </v-card-title>
                            <v-card-text>
                                Sumber dana pada transaksi QRIS adalah kartu debet, kartu kredit, dan/atau uang elektronik dari lembaga-lembaga yang disetujui oleh Bank Indonesia
                            </v-card-text>
                        </div>
                    </v-card>
                    <v-card class="faq mb-5 ml-8" width="630" height="200">
                        <div class="pa-2">
                            <v-card-title class="faqTitle">
                                Berapakah batas nominal transaksi menggunakan QRIS?
                            </v-card-title>
                            <v-card-text>
                                Nominal transaksi QRIS dibatasi paling banyak sebesar Rp 2.000.000,00 (dua juta rupiah) per transaksi
                            </v-card-text>
                        </div>
                    </v-card>
                <!-- </v-col> -->
            </v-row>
        </div>
    </v-container>
  </div>
</template>

<style scoped>
.faqTitle {
    color: #1A8D2B
}
</style>

<script>
    export default {
        
    }
</script>
